import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import userReducer from './slices/userSlice';
import appReducer from './slices/appSlice';
import deviceReducer from './slices/deviceSlice';
import colorsReducer from './slices/colorsSlice';
import authReducer from './slices/authSlice';
import iconsReducer from './slices/iconsSlice';
import menuReducer from './slices/menuSlice';
import searchReducer from './slices/searchSlice';
import  chatReducer from './slices/chatSlice';
import  chatCheckReducer from './slices/chatCheckSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  app: appReducer,
  device: deviceReducer,
  colors: colorsReducer,
  icons: iconsReducer,
  menu: menuReducer,
  search: searchReducer,
  chat: chatReducer,
  chatCheck: chatCheckReducer,
  
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
